<template>
    <div id="wrapper">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{ $t('string.msg.generate.bank.slips') }}</h4>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-12">
                            <div class="card-box">
                                <form>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.bank.slips.label.type') }}
                                            </label>
                                            <multiselect
                                                v-model="company"
                                                :options="companies"
                                                @input="filter()"
                                                :close-on-select="true"
                                                track-by="_id"
                                                :custom-label="customLabelCompany"
                                                :searchable="true"
                                                deselect-label="Remover"
                                                selected-label="Selecionado"
                                                select-label="Selecione"
                                                placeholder="Selecione o Associado"
                                            >
                                            </multiselect>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                {{ $t('string.msg.bank.slips.label.status') }}
                                            </label>
                                            <select id="status" v-model="filters.status" @change="filter()" class="form-control">
                                                <option :value="null">{{ $t('string.msg.select.selector.all.status') }}</option>
                                                <option value="PENDING_PAY">{{ $t('PENDING_PAY') }}</option>
                                                <option value="PAID">{{ $t('PAID') }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{ $t('response.msg.error.empty.fields') }}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                    </div>
                                </form>

                                <div v-if="filters.company" class="text-center cursor-pointer">
                                    <div class="form-row">
                                        <div class="form-group col-md-12 text-center" @click="checkForm">
                                            <i class="fas fa-barcode" style="font-size: 60px" v-tooltip="$t('string.msg.bank.slips.label.bankSlips')"></i><br />
                                            <label class="cursor-pointer m-0"
                                                ><strong
                                                    >{{ $t('string.msg.generate.bank.slip') }} do mês de: {{ $t('month-' + String(new Date().getMonth() + 1)) + '/' + new Date().getFullYear() }}</strong
                                                ></label
                                            >
                                        </div>
                                    </div>
                                </div>

                                <div class="pb-0 pt-3 cursor-pointer">
                                    <jw-pagination :items="items" @changePage="onChangePage" :labels="customLabels"></jw-pagination>
                                </div>
                                <div v-if="items && items.length > 0" class="table-responsive">
                                    <table class="table table-centered table-hover mb-0" id="datatable">
                                        <thead>
                                            <tr class="cursor-pointer">
                                                <th class="border-top-0 w-15">{{ $t('string.msg.bank.slips.label.date') }}</th>
                                                <th class="border-top-0 w-15">{{ $t('string.msg.bank.slips.label.status') }}</th>
                                                <th class="border-top-0 w-15" v-tooltip="$t('string.msg.bank.slips.last.update.description')">{{ $t('string.msg.bank.slips.last.update.label') }}</th>
                                                <th class="border-top-0 w-15">{{ $t('str.msg.total.bank.slip.label') }}</th>
                                                <th class="border-top-0 w-15">{{ $t('string.msg.bank.slips.label') }}</th>
                                                <th class="border-top-0 w-25">{{ $t('string.msg.bank.slips.label.company') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-bind:key="item._id" v-for="item in pageOfItems" class="cursor-pointer">
                                            <tr v-if="item && item.order && item.order.paymentObject">
                                                <td>
                                                    <span v-if="item.order.paymentObject.open_date">
                                                        {{ new Date(item.order.paymentObject.open_date).toLocaleDateString() + ' - ' + new Date(item.order.paymentObject.open_date).toLocaleTimeString() }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.order.paymentObject.status">
                                                        <span v-if="item.order.paymentObject.status == 'PE'" style="color: red">
                                                            <strong> {{ $t('str.msg.bank.slip.pendind.pay') }}</strong>
                                                        </span>
                                                        <span v-if="item.order.paymentObject.status == 'CO'" style="color: green">
                                                            <strong>{{ $t('str.msg.bank.slip.paid') }}</strong>
                                                        </span>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.order.paymentObject.status_date">
                                                        {{ new Date(item.order.paymentObject.status_date).toLocaleDateString() + ' - ' + new Date(item.order.paymentObject.status_date).toLocaleTimeString() }}
                                                    </span>
                                                    <span v-else> -- </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.order.paymentObject.amount_br"> R$ {{ Number(item.order.paymentObject.amount_br).toFixed(2) }} </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.order.paymentObject.boleto_url && item.order.paymentObject.status == 'PE'">
                                                        <span v-tooltip="$t('str.msg.download.bank.slip')">
                                                            <a target="_blank" :href="item.order.paymentObject.boleto_url"><i class="fas fa-download" style="color: black; font-size: 30px"></i></a>
                                                        </span>
                                                    </span>
                                                    <!-- <span v-if="!isCheckDate(item.order.paymentObject.due_date)" v-tooltip="$t('str.msg.unavailable')">  
                                                        <i class="fas fa-ban" style="color: gray"></i>
                                                    </span> -->
                                                    <span v-if="item.order.paymentObject.status == 'CO'" v-tooltip="$t('str.msg.unavailable')">
                                                        <i class="fas fa-ban" style="color: gray"></i>
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-if="item.company">
                                                        {{ item.company.socialName }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div v-if="errors.length" class="alert alert-danger">
                            <p class="lead">{{ $t('response.msg.error.empty.fields') }}</p>
                            <ul>
                                <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Toast :title="titleToast" :message="messageToast" />
        <EmailModal :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" :dueDate="dueDate" :email="email" :total="total" v-on:confirmation-return="returnModal" />
        <Spinner />
    </div>
</template>

<script>
import Controller from './CrtBankSlips'
import Spinner from '../../../components/layout/Spinner'
import Toast from '../../../components/layout/Toast'
import EmailModal from './Modal/ModalEmail'
export default {
    name: 'BankSlips',
    components: {
        Spinner,
        Toast,
        EmailModal,
    },
    data() {
        return {
            errors: [],
            titleToast: null,
            messageToast: null,
            messageIdToast: null,
            email: null,
            total: 14.9,
            dueDate: new Date(new Date().setDate(new Date().getDate() + 3)),
            companies: [],
            items: [],
            PageNumbers: 1,
            pageOfItems: [],
            company: null,
            hasBankSlipInMonth: true,
            filters: {
                company: null,
                status: null,
                isSearchForAdmin: true,
            },
            customLabels: {
                first: 'Primeira',
                last: 'Último',
                previous: 'Anterior',
                next: 'Próxima',
            },
        }
    },
    methods: Controller.methods,
    created() {},
    mounted() {
        Controller.init(this)
    },
}
</script>
    
<style>
.multiselect__content-wrapper /*, .multiselect__element */ {
    width: fit-content;
    overflow: auto;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
}
</style>